<template>
<drawer>
    <sidebar-links
        slot="body"
        :class="$style.sidebar_body"
        :items="links"
        :has-close-feature="true"
        :versions="versions"
        @click="onClickItem" />
</drawer>
</template>

<script>
import Drawer from "@/components/mdc/Drawer.vue";
import SidebarLinks from "@/components/SidebarLinks.vue";
import guideMixin from "@/components/guide.mixin";

const NCLK_CODES = {
    "outline": "outline",
    "app-register": "register",
    "login-api": "loginapi",
    "badge-guide": "badge"
};

export default {
    components: { Drawer, SidebarLinks },
    mixins: [guideMixin],
    props: {
        versions: { type: Array, default: null }
    },
    computed: {
        links() {
            const { name: current } = this.$route.params;
            const getLinks = (
                { title, path, children, version = "", isLatest = true },
                parent
            ) => {
                const result = { text: title, version, isLatest };
                const versionPath = version ? `/${version}` : "";
                if (children) {
                    result.children = children.map(link =>
                        getLinks(link, path));
                }
                if (parent) {
                    if (parent === current) {
                        result.href = `#${path}`;
                    } else {
                        result.to = `/guide/${parent}#${path}`;
                    }
                } else {
                    result.to = `/guide/${path}${versionPath}`;
                }
                result.path = `${path}${versionPath}`;
                return result;
            };
            return this.order.map(link => getLinks(link));
        }
    },
    methods: {
        onClickItem(e, path) {
            const versionRegex = /v[0-9]/;
            const hasVersion = path.match(versionRegex);
            const pathWithoutVersion = hasVersion ? path.split("/")[0] : path;
            this.$nc(e, `ctt.${NCLK_CODES[pathWithoutVersion]}`, {
                g_ssc: "whalespace_developers.guide"
            });
        }
    }
};
</script>

<style lang="scss" module>
@use "@/assets/scss/sidebar_layout";
</style>
